"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _async = _interopRequireDefault(require("async"));

var _uploadOptionsBase = _interopRequireDefault(require("./upload-options-base"));

var _batchManager = _interopRequireDefault(require("./batch-manager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * A queue that will ensure that a maximum number of items within it will
 * be processed concurrently. If at the max, additional items added to the
 * queue will be "blocked" until it's their turn for processing.
 *
 * The queue will automatically begin processing when an item is added, and
 * will restart if previously added items have all finished processing by the
 * time a new item is added.
 *
 * The queue provides the following events:
 * * error: sent if there is an error while processing one of the items in the
 *   queue. Event data will include an "item" property containing the item that
 *   failed (as it was provided when added to the queue), and an "error" property
 *   containing details of the error.
 * * emptied: sent when all the items in the queue have been processed. Could
 *   potentially be called multiple times, depending on the state of the queue
 *   when additional items are added.
 */
var ConcurrentQueue = /*#__PURE__*/function (_UploadOptionsBase) {
  _inherits(ConcurrentQueue, _UploadOptionsBase);

  var _super = _createSuper(ConcurrentQueue);

  /**
   * Constructs a new instance of the queue.
   * @param {object} options Used by the super class.
   * @param {DirectBinaryUploadOptions} uploadOptions Used to determine
   *  the maximum number of items to process concurrently. Retrieved using
   *  the options' getMaxConcurrent() method.
   */
  function ConcurrentQueue(options, uploadOptions) {
    var _this;

    _classCallCheck(this, ConcurrentQueue);

    _this = _super.call(this, options, uploadOptions);
    _this.queue = _async.default.queue( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(task, callback) {
        var data, worker, batch, err;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = task.data, worker = task.worker, batch = task.batch;
                _context.prev = 1;
                _context.next = 4;
                return worker(data);

              case 4:
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](1);
                err = _context.t0;

              case 9:
                _context.next = 11;
                return _this.batches.updateBatch(batch);

              case 11:
                callback(err);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 6]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }(), uploadOptions.getMaxConcurrent()); // send 'error' event if encountering an error while
    // processing an item.

    _this.queue.error(function (error, task) {
      var _task$data = task.data,
          data = _task$data === void 0 ? {} : _task$data;

      _this.emit('error', {
        item: data,
        error: error
      });
    }); // will be sent whenever all items added to the queue
    // have processed. may be sent multiple times throughout
    // the life of the queue.


    _this.queue.drain(function () {
      _this.emit('emptied', true);
    });

    _this.batches = new _batchManager.default();
    return _this;
  }
  /**
   * Adds a new item to the queue for processing.
   * @param {*} item The item to process.
   * @param {function} callback Will be invoked when the item is ready to
   *  be processed. The "callback" function is expected to return a promise. It will be
   *  invoked with a single argument: the item parameter provided in this method.
   * @returns {Promise} Will be resolved when the item has been processed.
   */


  _createClass(ConcurrentQueue, [{
    key: "push",
    value: function push(item, callback) {
      var _this2 = this;

      return new Promise(function (res) {
        _this2.queue.push({
          data: item,
          batch: _this2.batches.createBatch(1, res),
          worker: callback
        });
      });
    }
    /**
     * Adds an array of items to the queue for processing. Each item will be
     * passed to the same processing callback.
     * @param {Array} items Array of items to process.
     * @param {function} callback Will be invoked each time an item is ready to
     *  be processed (so it will be multiple times). The function is expected to
     *  return a promise. It will be invoked with a single argument: the item to
     *  be processed.
     * @returns {Promise} Will be resolved when all provided items have been processed.
     */

  }, {
    key: "pushAll",
    value: function pushAll(items, callback) {
      var _this3 = this;

      return new Promise(function (res) {
        var batch = _this3.batches.createBatch(items.length, res);

        items.forEach(function (item) {
          _this3.queue.push({
            data: item,
            batch: batch,
            worker: callback
          });
        });
      });
    }
    /**
     * Retrieves a value indicating whether there is currently anything in the
     * queue.
     * @returns {boolean} True if there are no items in the queue, false otherwise.
     */

  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.queue.idle();
    }
  }]);

  return ConcurrentQueue;
}(_uploadOptionsBase.default);

exports.default = ConcurrentQueue;